import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { call, get, sync } from 'vuex-pathify';
export default {
  name: 'DownloadSurveys',
  components: {
    FibCommonModal: require("../../components/CommonModal").default,
    FibDefaultSurvey: require("./DefaultSurvey").default
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    settingsDownload: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showDefault: false,
      showError: false,
      showSuccess: false,
      showWait: false
    };
  },
  computed: {
    defaultTemplate: sync('settings/defaultTemplate'),
    survey: get('surveys/survey'),
    surveyCount: get('surveys/surveyCount')
  },
  watch: {
    value: function value(activated) {
      if (activated) {
        this.downloadSurveys();
      }
    }
  },
  methods: {
    done: function done(result) {
      this.$emit('done', {
        name: 'config',
        result: result
      });
      this.$emit('input');
    },
    downloadSurveys: function downloadSurveys() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var ok;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Logger.debug('Download latest survey settings');
                _this.showWait = true;
                _context.next = 4;
                return _this.fetchConfig(_this.settingsDownload);

              case 4:
                ok = _context.sent;

                if (!ok) {
                  _context.next = 9;
                  break;
                }

                _context.next = 8;
                return _this.fetchSurveys();

              case 8:
                ok = _context.sent;

              case 9:
                _this.showWait = false;

                if (ok) {
                  _this.showSuccess = true;
                } else {
                  _this.showError = true;
                }

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    promptForDefaultTemplate: function promptForDefaultTemplate() {
      // Set default template to none and don't prompt for a default if no surveys are available
      if (this.surveyCount === 0) {
        this.defaultTemplate = 0;
        this.done(true);
        return;
      } // Prompt for for a default survey if the current default is no longer available


      if (this.defaultTemplate && !this.survey(this.defaultTemplate)) {
        this.showDefault = true;
      } else {
        this.done(true); // Default template is still valid, so we're done
      }
    },
    fetchConfig: call('config/fetchConfig'),
    fetchSurveys: call('surveys/fetchSurveys')
  }
};